<template>
    <div class="nature-talent-data-area">
        <div class="nature-talent-data" v-bind:id="canvasId"></div>
        <div class="nature-talent-legend">
            <span class="nature-talent-l-item gray"><span class="nature-tli-squre"></span>{{natureTalentData.chartDataList[0].name}}</span>
            <span class="nature-talent-l-item yellow"><span class="nature-tli-squre"></span>{{natureTalentData.chartDataList[1].name}}</span>
            <span class="nature-talent-l-item blue"><span class="nature-tli-squre"></span>{{natureTalentData.chartDataList[2].name}}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NatureTalentDataArea',
    props: {
        resultType: {
            type: String,
            default() { return '' }
        },
    },
    computed: {
        natureTalentData() {
            return this.resultType == 'year' ? this.$store.state.year.curYearReportTalentData : this.$store.state.report.natureTalentData;
        }
    },
    data() {
        return {
            canvasId: 'talentData'
        }
    },
    mounted() {
        var me = this;
        setTimeout(() => {
            me.initEcharts();
        }, 20);
    },
    methods: {
        initEcharts() {
            var me = this;
            var canvasDom = document.getElementById(this.canvasId);
            if(canvasDom == null) { return; }
            // 基于准备好的dom，初始化echarts实例
            var myChart = this.$echarts.init(canvasDom);
            myChart.setOption({
                radar: {
                    splitNumber: 5,
                    axisLine: {
                        lineStyle: {
                            color: ['#EDEDEF']
                        }
                    },
                    splitLine: {
                        lineStyle: {
                            color: ['#EDEDEF']
                        }
                    },
                    splitArea: {
                        areaStyle: {
                            opacity: 0
                        }
                    },
                    indicator: me.natureTalentData.chartIndicator
                },
                series: [{
                    type: 'radar',
                    // label: {
                    //     show: false,
                    //     color: '#758091',
                    //     fontSize: 16,
                    //     padding: [0, 0]
                    // },
                    data: me.natureTalentData.chartDataList
                }]
            });
        }
    }
}
</script>